<app-change-course-header
  [heading]="
    'Admin : Course Management : Practice Test : StudyUnit and Question Selection' +
    (practiceTestName
      ? ' : ' + practiceTestName
      : practiceTestSequenceNumber
      ? ' : Practice Test ' + practiceTestSequenceNumber
      : '')
  "
  [showChangeCourse]="false"
></app-change-course-header>
<!-- ================= SUBJECT SELECT BAR ================= -->
<div class="row">
  <div class="col-12 border-bottom d-flex align-items-center gap-2 py-2">
    <!-- Subject Dropdown -->
    <div class="col-2">
      <select
        class="form-control form-control-sm"
        [(ngModel)]="selectedSubject"
        (change)="SelectSubject($event)"
        [disabled]="subjectLocked"
      >
        <option [value]="0">Select Subject</option>

        <option
          class="border-bottom"
          *ngFor="let s of subjectList"
          [value]="s.ID"
        >
          {{ s.Name }}
        </option>
      </select>
    </div>

    <!-- Select Study Units -->
    <div class="col-2">
      <button
        class="btn btn-sm btn-primary"
        (click)="navigateToStudyUnitSelection()"
        *ngIf="subjectLocked"
      >
        Select Study Units
      </button>
    </div>
  </div>
</div>

<!-- ================= QUESTIONS TABLE ================= -->
<div class="row mt-3">
  <div class="container">
    <div *ngFor="let subject of subjectWithQuestions">
      <div *ngIf="subject.questions?.length">
        <!-- Subject Header -->
        <p class="fw-semibold mb-2" style="color: #0c4788">
          {{ subject.Subject_Name }}
          <span class="ms-2 text-dark">
            {{ subject.Subject_Current_Number_Of_Question }}
          </span>
          /
          <span class="text-dark">
            {{ subject.Subject_Total_Number_Of_Question }}
          </span>
        </p>

        <!-- Questions Card -->
        <div class="card mb-3">
          <div class="card-body p-2">
            <table class="table table-bordered mb-0">
              <thead>
                <tr>
                  <th class="text-center" style="width: 4%">#</th>
                  <th style="width: 15%">Topic</th>
                  <th style="width: 12%">Question Id</th>
                  <th>Question</th>
                  <th style="width: 30%">Answer Choices</th>
                  <th class="text-center" style="width: 8%">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let q of subject.questions; let i = index">
                  <td class="text-center align-middle">{{ i + 1 }}</td>

                  <td class="align-middle">{{ q.Path_Name }}</td>

                  <td class="align-middle">{{ q.Question_ID }}</td>

                  <td class="align-middle" [innerHTML]="q.Question_Text"></td>

                  <!-- Answer Choices -->
                  <td class="align-middle">
                    <ul class="list-unstyled mb-0">
                      <li *ngFor="let c of q.Answer_Choices">
                        <div class="d-flex align-items-start gap-2">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            [checked]="c.selected"
                            disabled
                          />

                          <strong *ngIf="c.Right_Answer_Ind === 'Y'">
                            [R]
                          </strong>

                          <span [innerHTML]="c.Answer_Choice_Text"></span>
                        </div>
                      </li>
                    </ul>
                  </td>

                  <!-- Actions -->
                  <td class="text-center align-middle">
                    <i
                      class="fa fa-trash pointer-cursor"
                      (click)="onDelete(subject, q)"
                    ></i>
                    <i
                      class="fa fa-pencil ms-2 pointer-cursor"
                      (click)="onEdit(subject, q)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
